export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11045.ddce2ef4.jpg";